const { getVisualFiltersConfig } = require('./config');

const getVisualFiltersById = (subCategoryId, nestedSubCategoryId) =>
    getVisualFiltersConfig().find((el) => el.id === subCategoryId || el.id === nestedSubCategoryId);

module.exports = {
    getVisualFiltersById,
};
